import { evaluateMetaSevenDaySendBlock } from "@redotech/effect-api-shared/models/shopper-ai/conversation/message/block-rule";
import type { BlockContext, BlockRule, BlockedResult } from "../types";

type MetaDmChannel = "facebookDm" | "instagramDm";

function isMetaDmChannel(channel: string): channel is MetaDmChannel {
  return channel === "facebookDm" || channel === "instagramDm";
}

/**
 * Meta's messaging API only allows sending a DM within 7 days of the most
 * recent customer DM. Mirrors the v1 `canSendMetaMessage` business rule in
 * `redo/merchant/support/app/src/utils.ts`.
 */
export const metaSevenDayRule: BlockRule = (
  ctx: BlockContext,
): BlockedResult | null => {
  if (!isMetaDmChannel(ctx.channel)) {
    return null;
  }
  return evaluateMetaSevenDaySendBlock({
    channel: ctx.channel,
    messages: ctx.messages,
    messagesLoading: ctx.messagesLoading,
  });
};
